import { useState } from 'react';
import client from '../../api/client';
import { useUser } from '../../context/UserContext';
import Spinner from '../Global/Spinner';
import { useParams } from 'react-router-dom';

function EnhanceButton({ setPost, blogId = '' }) {
	const { user } = useUser();
	const [loading, setLoading] = useState(false);
	const { id } = useParams();
	const initiateEnhancement = async (e) => {
		try {
			e.preventDefault();
			setLoading(true);
			const { data } = await client.get(
				`/blog/enhance/${blogId ? blogId : id}`
			);
			if (data) setPost(data.post);
			setLoading(false);
		} catch (error) {
			return console.error(error);
		}
	};
	if (user && user.isAdmin)
		return (
			<button
				className='text-sm font-semibold leading-6 text-primary-200 bg-gray-900 border-2 border-primary-200 shadow-md rounded-md px-4 py-2 hover:bg-gray-700 hover:text-white'
				onClick={initiateEnhancement}
				disabled={loading}
			>
				{loading ? <Spinner /> : 'Enhance Post'}
			</button>
		);
}
export default EnhanceButton;
